<template>
    <div class="home-block">
        <div
        class="recent-header"
        :class="isCollapse?'header-collapse':''">
            <div>{{ blockIndex }}</div>
            <div class="recent-title">
            <div>{{ blockTitle }}</div>
            <div>{{ blockTitleEng }}</div>
            </div>
            <div v-if="isCollapse" class="home-recent-more header-more" @click="goto(link)">+</div>
        </div>
        <div
        class="recent-body"
        :class="isCollapse?'body-collapse':''">
            <div v-if="!isCollapse" class="recent-placeholder"></div>
            <slot></slot>
        </div>
        <div v-if="!isCollapse"  class="recent-footer">
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>

import { useScreenState } from '../../../store';

export default {
  name: 'HomeBlock',
  props: {
    blockIndex: String,
    blockTitle: String,
    blockTitleEng: String,
    link: String,
  },
  data() {
    return {
      screenState: useScreenState(),
    }
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    goto(url) {
      if (url)
        this.$router.push(url)
    },
  },
}
</script>

<style scoped>

.home-block {
  margin-top: calc(48 / 1920 * 100vw);
  /* width: 40vw; */
}

.recent-header {
  color: #C6A86C;
  border-bottom: 1px solid #2F2F2F;
  font-weight: normal;
  display: flex;
}

.header-collapse {
    border-bottom: none;
}

.recent-header > div:first-child {
  border-right: 1px solid #2F2F2F;
  font-size: 3.8vw;
  color: #C6A86C;
  width: 5.2vw;
  display: flex;
  align-items: center;
}

.header-collapse > div:first-child {
    border-right: none;
    font-size: calc(3vw + 11px);
}

.recent-title {
  padding: 8px 13px 6px 13px;
}

.recent-title > div:first-child {
  font-size: 3vw;
  line-height: 3vw;
  min-height: 15px;
}

.header-collapse .recent-title > div:first-child {
  font-size: calc(1vw + 18px);
  line-height: calc(1vw + 18px);
  margin-top: 1vw;
}

.recent-title > div:last-child {
  font-size: 1.5vw;
  line-height: 1.5vw;
  min-height: 8px;
}

.header-collapse .recent-title > div:last-child {
  font-size: calc(0.5vw + 9px);
  line-height: calc(0.5vw + 9px);
  margin-top: 1vw;
}

.recent-body {
  border-bottom: 1px solid #2F2F2F;
  display: flex;
}

.body-collapse {
  border-bottom: none;
}

.recent-placeholder {
  border-right: 1px solid #2F2F2F;
  width: 5.2vw;
  padding: auto;
}

.recent-footer > div:first-child {
  border-right: 1px solid #2F2F2F;
  width: 5.2vw;
  height: 5.2vw;
}

.header-more {
    margin-top: 35px;
}

</style>
